module.exports = __webpack_public_path__ + "img/top_inside_left.38d63e8d.svg";